import { render, staticRenderFns } from "./calenderIcon.vue?vue&type=template&id=2b32fa5c&"
import script from "./calenderIcon.vue?vue&type=script&lang=js&"
export * from "./calenderIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports